<template>
  <v-card class="mx-auto accent-4 ml-2" max-width="100%" min-height="100%">
    <v-row class="primary pa-4 mx-0 pb-4 px-10" justify="center">
      <v-text-field
        v-model="search"
        class="text--black mt-2"
        clear-icon="mdi-close-circle-outline"
        clearable
        dark
        hide-details
        label="Search by Location(Region, Zone, Woreda, and City)"
        outlined
        style="max-width: 50%; font-size: 16px"
      ></v-text-field>
    </v-row>
    <v-card-text>
      <div class="text-center">
        <v-dialog v-model="dialog" width="100%">
          <v-card>
            <v-card-title class="text-h6 justify-center grey lighten-2">
              <v-spacer></v-spacer>
     
              Data Completeness Report For &nbsp;{{
                this.selected ? this.selected.name : ""
              }}
              <v-spacer></v-spacer>
              <v-btn small color="primary darken-2" @click="close()">
             
                Close
              </v-btn>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-container>
                
                <completeness-info
                  v-if="this.selected"
                  :id="this.selected.id"
                  :part-of="this.partOf"
                  :name="this.selected.name"
                  :closed="this.dialog"
                ></completeness-info>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <v-row class="mt-2" style="margin-left: 10%">
        <h2 v-if="items.length === 0" class="mt-3">Loading...</h2>
        <v-treeview
          v-model="selection"
          :items="items"
          :load-children="fetchChildren"
          :loading="loading"
          :open.sync="open"
          :search="search"
          activatable
          item-disabled="locked"
          light
          open-on-click
          return-object
          selection-type="independent"
          style="font-size: 1.4em"
        >
          <template slot="label" slot-scope="{ item }">
            <v-icon
              v-if="types.find((x) => x.name === item.name)"
              class="pr-2"
              color="teal darken-2"
            >
              mdi-domain
            </v-icon>
            <v-icon v-else class="pr-2" color="green darken-2">
              mdi-hospital-building
            </v-icon>
            <a @click="openDialog(item)">{{ item.name }}</a>
          </template>
        </v-treeview>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import completenessInfo from "../completnessInfo.vue";

const querystring = require("querystring");
export default {
  components: { completenessInfo },
  data: function () {
    return {
      partOf: false,
      dialog: false,
      source: { path: "", data: {} },
      value: { reference: "" },
      loading: false,
      items: [],
      selection: [],
      select: "",
      displayValue: "",
      preset: false,
      open: [],
      treeLookup: {},
      allAllowed: true,
      isFacility: false,
      search: null,
      selected: null,
      locationData: {
        name: "",
        type: "",
        status: "",
      },
      types: [
        {
          id: "2",
          name: "Health Science College",
          locked: false,
          type: "health-science-college",
          children: [],
        },
        {
          id: "3",
          name: "Agencies",
          locked: false,
          type: "agencies",
          children: [],
        },
        {
          id: "4",
          name: "NGO's",
          locked: false,
          type: "ngo",
          children: [],
        },
        {
          id: "5",
          name: "Federal Hospitals",
          locked: false,
          type: "federal-hospitals",
          children: [],
        },
        {
          id: "6",
          name: "Association",
          locked: false,
          type: "association",
          children: [],
        },
        {
          id: "federal-ministry-of-health",
          name: "Regions",
          locked: false,
          type: "regions",
          children: [],
        },
      ].sort((a, b) => {
        return a.name.localeCompare(b.name);
      }),
    };
  },
  created: function () {
    this.setupData();
    this.loadLocationType();
    this.loadLocationStatus();
  },
  watch: {
    slotProps: {
      handler() {
        this.setupData();
      },
      deep: true,
    },
    select: function (val) {
      this.value.reference = val;
      this.getDisplay();
    },
    search: function (val) {
      let url = `/fhir/Location?name=${val}&_include=Location:partof&_sort=name`;
      this.items = [];
      if (val.length === 0) {
        this.setupData();
      } else {
        this.addItems(url, this.items);
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    openDialog(item) {
      if (!this.types.find((x) => x.name === item.name)) {
        this.dialog = true;
        this.selected = item;
      }
    },
    setupData: function () {
      this.setupTreeItems();
    },
    setupTreeItems: async function () {
      let treetop = this.initialValue;
      if (this.overrideValue) {
        treetop = this.overrideValue;
      }
      this.loading = true;
      let params = {};
      if (treetop) {
        await this.checkFacility(treetop);
        if (this.isFacility) {
          params = { _id: treetop };
        } else {
          params = { partof: treetop };
        }
      } else {
        params = { "partof:missing": true };
      }
      params.sort = "name";
      params._count = 500;
      let facilityId = this.$store.state.user.facilityId;
      let url = `/fhir/Location?_profile=http://ihris.org/fhir/StructureDefinition/ihris-facility&_sort=name&_id=${facilityId}&_count=500`;
      this.items = [];
      this.addItems(url, this.items);
    },
    checkFacility: function () {

   
      let url = "/fhir/Facility?name=name&_sort=name";
      return new Promise((resolve) => {
        fetch(url)
          .then((response) => {
            if (response.ok) {
              response
                .json()
                .then((data) => {
                  if (data.total && data.total == 1) {
                    this.isFacility = true;
                  }
                  resolve();
                })
                .catch((err) => {
                  console.log("failed to check facility for", url, err);
                  resolve();
                });
            } else {
              console.log("failed to check facility for", url, response.status);
              resolve();
            }
          })
          .catch((err) => {
            console.log("failed to check facility for", url, err);
            resolve();
          });
      });
    },
    checkChildren: function (item) {
      let params = { partof: item.id, _summary: "count" };
      let url =
        "/fhir/Location?_sort=name" + "&" + querystring.stringify(params);
      return new Promise((resolve) => {
        fetch(url)
          .then((response) => {
            if (response.ok) {
              response
                .json()
                .then((data) => {
                  if (data.total && data.total > 0) {
                    item.children = [];
                  }
                  resolve();
                })
                .catch((err) => {
                  console.log("failed to check children for", url, err);
                  resolve();
                });
            } else {
              console.log("failed to check children for", url, response.status);
              resolve();
            }
          })
          .catch((err) => {
            console.log("failed to check children for", url, err);
            resolve();
          });
      });
    },
    addItems: function (url, items) {
      fetch(url)
        .then((response) => {
          if (response.ok) {
            response
              .json()
              .then(async (data) => {
                if (data.entry && data.entry.length > 0) {
                  for (let entry of data.entry) {
                    // let locked = this.allAllowed ? false : !entry.resource.meta.profile.includes(this.targetProfile)
                    let locked = false;
                    let item = {
                      id: entry.resource.resourceType + "/" + entry.resource.id,
                      name: entry.resource.name,
                      locked: locked,
                      type: entry.resource.type[0].coding[0].code,
                    };
                  
                    await this.checkChildren(item);
                    this.treeLookup[item.id] = item.name;
                    let facilityId = this.$store.state.user.facilityId;

                    if (
                      facilityId === "federal-ministry-of-health" &&
                      item.id === "Location/federal-ministry-of-health"
                    ) {
                      for (let item of this.types) {
                        await this.checkChildren(item);
                        this.treeLookup[item.id] = item.name;
                      }
                      item.children = this.types;
                    }
                    items.push(item);
                  }
                }
                if (data.link) {
                  let next = data.link.find((link) => link.relation === "next");
                  if (next) {
                    this.addItems(next.url, items);
                  } else {
                    this.loading = false;
                  }
                } else {
                  this.loading = false;
                }
              })
              .catch((err) => {
                console.log("Failed to add items for", url, err);
                this.loading = false;
              });
          } else {
            console.log("Failed to add items for", url, response.status);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log("Failed to add items for", url, err);
          this.loading = false;
        });
    },
    fetchChildren: function (item) {
      let params = { partof: item.id, _count: 5000 };
      if (
        item.name === "Agencies" &&
        item.type === "agencies" &&
        item.id === "3"
      ) {
        params = {
          type: "AGN",
          partof: "federal-ministry-of-health",
          _count: 5000,
        };
      }
      if (
        item.name === "Association" &&
        item.type === "association" &&
        item.id === "6"
      ) {
        params = {
          type: "ASSO",
          partof: "federal-ministry-of-health",
          _count: 5000,
        };
      }
      if (item.name === "NGO's" && item.type === "ngo" && item.id === "4") {
        params = {
          type: "NGOs",
          partof: "federal-ministry-of-health",
          _count: 5000,
        };
      }
      if (
        item.name === "Federal Hospitals" &&
        item.type === "federal-hospitals" &&
        item.id === "5"
      ) {
        params = {
          type: "FH",
          partof: "federal-ministry-of-health",
          _count: 5000,
        };
      }
      if (
        item.name === "Regions" &&
        item.type === "regions" &&
        item.id === "federal-ministry-of-health"
      ) {
        params = {
          type: "RHO",
          partof: item.id,
          _count: 5000,
        };
      }
      if (
        item.name === "Health Science College" &&
        item.type === "health-science-college" &&
        item.id === "2"
      ) {
        params = {
          type: "HSC",
          partof: "federal-ministry-of-health",
          _count: 5000,
        };
      }
      let url =
        "/fhir/Location?&_sort=name" + "&" + querystring.stringify(params);
      this.loading = true;

      this.addItems(url, item.children);

      return new Promise((resolve) => {
        let count = 0;
        const checkLoading = () => {
          if (!this.loading || count++ > 100) {
            resolve();
          } else {
            setTimeout(checkLoading, 200);
          }
        };
        checkLoading();
      });
    },
    querySelections: function (val) {
      this.loading = true;
      let params = { "name:contains": val };
      if (!this.targetProfile.endsWith(this.resource)) {
        params._profile = this.targetProfile;
      }
      let url =
        "/fhir/Location?_sort=name" + "&" + querystring.stringify(params);
      fetch(url).then((response) => {
        if (response.ok) {
          response.json().then(async (data) => {
            this.items = [];
            if (data.entry && data.entry.length) {
              for (let entry of data.entry) {
                let ref = entry.resource.resourceType + "/" + entry.resource.id;
                let item = { value: ref };
                item.text = await this.$fhirutils.resourceLookup(ref);
                this.items.push(item);
              }
            }
            this.loading = false;
          });
        } else {
          console.log("Failed to retrieve", this.resource);
          this.loading = false;
        }
      });
    },
    getDisplay: function () {
      if ((!this.edit || this.preset) && this.value && this.value.reference) {
        this.loading = true;
        this.$fhirutils.resourceLookup(this.value.reference).then((display) => {
          this.displayValue = display;
          if (this.displayType !== "tree") {
            this.items.push({ text: display, value: this.value.reference });
          }
          this.loading = false;
        });
      }
    },
    loadLocationType: function () {
      let url = "/fhir/ValueSet/ihris-jurisdiction-type/$expand";
      fetch(url).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            if(this.locationFilter){
            this.locationType = data.expansion.contains.filter(
              (l) => !this.locationFilter.includes(l.code.toLowerCase())
            );
            }
          });
        }
      });
    },
    loadLocationStatus: function () {
      let url = "/fhir/ValueSet/location-status/$expand";
      fetch(url).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            this.locationStatus = data.expansion.contains;
          });
        }
      });
    },
  },
  computed: {
    index: function () {
      if (this.slotProps) return this.slotProps.input;
      else return undefined;
    },
    display: function () {
      if (this.slotProps && this.slotProps.input)
        return this.slotProps.input.label;
      else return this.label;
    },
    required: function () {
      return (this.index || 0) < this.min;
    },
    rules: function () {
      if (this.required) {
        return [(v) => !!v || this.display + " is required"];
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped >
.description {
  color: #000;
}
.v-input__control,
.v-input__slot,
.v-text-field.v-text-field--enclosed {
  border-radius: 25px !important;
}
.v-application .primary {
  background-color: #0d3552 !important;
  border-color: var(--v-primary-base) !important;
}
.description strong {
  color: #e00e0e;
}
</style>
